import React, { useState } from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { useSelector } from "react-redux";

import { useCart } from "../../components/CartContext";

import "./css/Header.css";


function Header() {

  const {
    restaurantId,
    tableId,
  } = useParams();


  const navigate =
    useNavigate();


  const location =
    useLocation();


  const [
    menuOpen,
    setMenuOpen,
  ] = useState(false);


  /*
  =======================================================
  RESTAURANT
  =======================================================
  */

  const themeState =
    useSelector(
      (state) => state.theme
    );


  const restaurantName =
    themeState?.restaurantName ||
    themeState?.restaurant_name ||
    "CYMA";


  /*
  =======================================================
  CART
  =======================================================
  */

  const {
    cartCount,
  } = useCart();


  /*
  =======================================================
  HOME PATH
  =======================================================
  */

  const homePath =
    `/${restaurantId}/table/${tableId}`;


  /*
  =======================================================
  CLOSE MOBILE MENU
  =======================================================
  */

  const closeMenu = () => {

    setMenuOpen(false);

  };


  /*
  =======================================================
  HOME
  =======================================================
  */

  const handleHomeClick = () => {

    closeMenu();


    /*
    Already on HomeScreen
    */

    if (
      location.pathname ===
      homePath
    ) {

      window.scrollTo({

        top: 0,

        behavior: "smooth",

      });

      return;

    }


    /*
    Coming from:

    Cart
    Checkout
    Order
    Payment
    Success

    Go back to Home.
    */

    navigate(
      homePath
    );

  };


  /*
  =======================================================
  GLOBAL SECTION NAVIGATION
  =======================================================

  If already on HomeScreen:

      scroll directly.

  If on another screen:

      HomeScreen + hash.

  Example:

      /restaurant/5/table/2#theme5-menu

  HomeScreen detects the hash and scrolls to MENU.
  =======================================================
  */

  const goToSection = (
    sectionId
  ) => {

    closeMenu();


    /*
    =====================================================
    ALREADY ON HOMEPAGE
    =====================================================
    */

    if (
      location.pathname ===
      homePath
    ) {

      const element =
        document.getElementById(
          sectionId
        );


      if (element) {

        const headerHeight =
          window.innerWidth <= 750
            ? 68
            : 82;


        const elementPosition =
          element.getBoundingClientRect().top +
          window.pageYOffset;


        window.scrollTo({

          top:
            elementPosition -
            headerHeight -
            10,

          behavior:
            "smooth",

        });

      }

      return;

    }


    /*
    =====================================================
    COMING FROM CART / CHECKOUT / ORDER / PAYMENT
    =====================================================

    Navigate to HomeScreen with hash.
    */

    navigate({

      pathname:
        homePath,

      hash:
        `#${sectionId}`,

    });

  };


  /*
  =======================================================
  CART
  =======================================================
  */

  const handleCartClick = () => {

    closeMenu();


    navigate(
      `${homePath}/cart`
    );

  };


  return (

    <>

      {/* =================================================
          HEADER
      ================================================= */}

      <header className="theme5-header">

        <div className="theme5-header-container">


          {/* =================================================
              RESTAURANT LOGO
          ================================================= */}

          <button

            type="button"

            className="theme5-logo"

            onClick={
              handleHomeClick
            }

          >

            <span className="theme5-logo-name">

              {restaurantName}

            </span>


            <span className="theme5-logo-caption">

              GREEK TAVERNA

            </span>

          </button>


          {/* =================================================
              DESKTOP NAVIGATION
          ================================================= */}

          <nav className="theme5-desktop-nav">


            {/* HOME */}

            <button

              type="button"

              onClick={
                handleHomeClick
              }

            >
              HOME
            </button>


            {/* ABOUT */}

            <button

              type="button"

              onClick={() =>
                goToSection(
                  "theme5-story"
                )
              }

            >
              ABOUT
            </button>


            {/* MENU */}

            <button

              type="button"

              onClick={() =>
                goToSection(
                  "theme5-menu"
                )
              }

            >
              MENU
            </button>


            {/* GALLERY */}

            <button

              type="button"

              onClick={() =>
                goToSection(
                  "theme5-gallery"
                )
              }

            >
              GALLERY
            </button>


            {/* CATERING */}

            <button

              type="button"

              onClick={() =>
                goToSection(
                  "theme5-catering"
                )
              }

            >
              CATERING
            </button>


            {/* CONTACT */}

            <button

              type="button"

              onClick={() =>
                goToSection(
                  "theme5-opa"
                )
              }

            >
              OPA! MOMENTS 
            </button>

          </nav>


          {/* =================================================
              RIGHT SIDE
          ================================================= */}

          <div className="theme5-header-actions">


            {/* =================================================
                CART ICON
            ================================================= */}

            <button

              type="button"

              className="theme5-cart-button"

              onClick={
                handleCartClick
              }

              aria-label="Shopping cart"

            >

              <svg

                className="theme5-cart-icon"

                viewBox="0 0 24 24"

                aria-hidden="true"

              >

                <path

                  d="
                    M3 4
                    h2
                    l2.4 11.2
                    a2 2 0 0 0 2 1.6
                    h7.9
                    a2 2 0 0 0 1.9-1.4
                    L21 8
                    H6
                  "

                />


                <circle

                  cx="10"

                  cy="20"

                  r="1.4"

                />


                <circle

                  cx="18"

                  cy="20"

                  r="1.4"

                />

              </svg>


              {cartCount > 0 && (

                <span
                  className="theme5-cart-badge"
                >

                  {cartCount}

                </span>

              )}

            </button>


            {/* =================================================
                MOBILE MENU BUTTON
            ================================================= */}

            <button

              type="button"

              className={
                `theme5-menu-toggle ${
                  menuOpen
                    ? "theme5-menu-toggle-open"
                    : ""
                }`
              }

              onClick={() =>
                setMenuOpen(
                  !menuOpen
                )
              }

              aria-label="Open navigation"

              aria-expanded={
                menuOpen
              }

            >

              <span></span>

              <span></span>

              <span></span>

            </button>

          </div>

        </div>

      </header>


      {/* =================================================
          MOBILE NAVIGATION
      ================================================= */}

      <div

        className={
          `theme5-mobile-menu ${
            menuOpen
              ? "theme5-mobile-menu-open"
              : ""
          }`
        }

      >

        <div className="theme5-mobile-menu-inner">


          {/* HOME */}

          <button

            type="button"

            onClick={
              handleHomeClick
            }

          >
            HOME
          </button>


          {/* ABOUT */}

          <button

            type="button"

            onClick={() =>
              goToSection(
                "theme5-story"
              )
            }

          >
            ABOUT
          </button>


          {/* MENU */}

          <button

            type="button"

            onClick={() =>
              goToSection(
                "theme5-menu"
              )
            }

          >
            MENU
          </button>


          {/* GALLERY */}

          <button

            type="button"

            onClick={() =>
              goToSection(
                "theme5-gallery"
              )
            }

          >
            GALLERY
          </button>


          {/* CATERING */}

          <button

            type="button"

            onClick={() =>
              goToSection(
                "theme5-catering"
              )
            }

          >
            CATERING
          </button>


          {/* CONTACT */}

          <button

            type="button"

            onClick={() =>
              goToSection(
                "theme5-opa"
              )
            }

          >
            OPA! MOMENTS
          </button>


          {/* CART */}

          <button

            type="button"

            className=
              "theme5-mobile-cart-button"

            onClick={
              handleCartClick
            }

          >

            <span>
              VIEW CART
            </span>


            {cartCount > 0 && (

              <strong>
                {cartCount}
              </strong>

            )}

          </button>

        </div>

      </div>

    </>

  );

}


export default Header;